module.exports = __webpack_public_path__ + "assets/visa_icon-d1f94d.svg";